export default __webpack_public_path__ + "app/views/intradays/intradays.html";